import ClientLike from "../client-like";

export default class ProjecTaskTypeApi {
  public constructor(private client: ClientLike) {}

  public async all(projectId: number): Promise<ProjectTaskType[]> {
    const data: any[] = await this.client.get("get_project_task_types.php", {
      projectId
    });
    return data.map(
      i => new ProjectTaskType(i.taskTypeId, i.name, i.serviceTemplateTypeId)
    );
  }
}

class ProjectTaskType {
  public constructor(
    public id: number,
    public name: string,
    public serviceTemplateTypeId: any
  ) {}
}
